import { render, staticRenderFns } from "./EditAccountForm.vue?vue&type=template&id=3c113e94&"
import script from "./EditAccountForm.vue?vue&type=script&lang=js&"
export * from "./EditAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports